import styled from "styled-components";
import { motion } from "framer-motion";

export const Wrap = motion(styled.div`
  flex: 1;
  display: flex;
  > * {
    margin: 0 3px;
    width: 50%;
  }
 @media(max-width: 1199px) {
   width: 100%;
   margin-bottom: 15px;
  }
`);
